import React, { useContext } from 'react';
import Button from '../Button/Button';
import { FormDataContext } from '../FormDataContext/WithFormDataContext';
import axios from 'axios';

const RequestResult = ({ result, final }) => {
  const [formData] = useContext(FormDataContext);

  React.useEffect(() => {
    if (result === 'A') {
      const contact = {
        email: formData.customerProfile.contactMethod.email,
        fastapp_reference_number: formData.referenceNumber,
        type_of_form_submitted: 'Vehicle Application'
      };

      const fetchData = async () => {
        try {
          const res = await axios.post(
            'https://us-central1-fasttrack-client.cloudfunctions.net/api/contact',
            contact,
          );
          console.log('Contact response:', res);
        } catch (error) {
          console.log(error);
        }
      };

      fetchData();
    }
  }, []);

  if (result === 'A') {
    if (final) {
      return (
        <div className="text-suzGreen flex flex-col items-center mb-24">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-20 w-20 mb-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <h3 className="text-center text-3xl font-medium text-white">
            Your application has been provisionally accepted. Your reference
            number is {formData.referenceNumber}.
          </h3>
          <h3 className="text-center text-2xl font-light text-white mt-16">
            Be sure to take this reference to your nearest dealer to complete
            the process.
          </h3>
        </div>
      );
    }
    return (
      <div className="text-suzGreen flex flex-col items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-20 w-20 mb-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <h3 className="text-center w-3/4 mx-auto text-2xl uppercase tracking-widest text-white">
          Congratulations! Your pre-approval request was successful. Select your
          deal below:
        </h3>
      </div>
    );
  }

  if (result === 'E') {
    return (
      <div className="text-red-600 flex flex-col items-center mb-24">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-20 w-20 mb-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <h3 className="text-center text-2xl font-medium text-white">
          There has been an error processing your request at this time.
        </h3>
        <Button
          text="Retry"
          action={() => {
            window.location.reload();
          }}
        />
      </div>
    );
  }

  if (result === 'D') {
    return (
      <div className="text-red-600 flex flex-col items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-20 w-20 mb-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <h3 className="text-center text-2xl font-medium text-white">
          Sorry, your pre-approval application has been declined. Please get in
          touch with your bank to find out more.
        </h3>
      </div>
    );
  }

  if (result === 'R') {
    return (
      <div className="text-yellow-500 flex flex-col items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-20 w-20 mb-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <h3 className="text-center text-2xl font-medium text-white">
          You application has been referred. Please get in touch with your bank
          to find out more.
        </h3>
      </div>
    );
  }

  if (result === 'REF') {
    return (
      <div className="text-yellow-500 flex flex-col items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-20 w-20 mb-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <h3 className="text-center text-2xl font-medium text-white">
          You application has been referred. Please select a new deal below:
        </h3>
      </div>
    );
  }

  return <div></div>;
};

export default RequestResult;
